import {PatientCorrectionRequest} from 'gabi-api-ts/v2/patient/command/patient_command';
import {Patient} from 'gabi-api-ts/v2/patient/command/patient_command';
import {PatientCommandServiceClient} from 'gabi-api-ts/v2/patient/command/patient_command.client';
import {Patient as PatientQ} from 'gabi-api-ts/v2/patient/query/patient_query';
import {PatientQueryServiceClient} from 'gabi-api-ts/v2/patient/query/patient_query.client';

import {grpcRequest} from '@/services/api-requests/grpc-request-ts';
import {Auth0Service} from '@/services/auth0-service';

export class PatientRequestService_ {
    async createPatient(newPatient: Patient): Promise<PatientQ> {
        const accessToken = await Auth0Service.getAccessToken();
        const req = await grpcRequest(
            accessToken ?? '',
            PatientCommandServiceClient,
            PatientCommandServiceClient.prototype.createPatient,
            newPatient,
        );

        // Wait for patient to be created
        await new Promise((r) => setTimeout(r, 500));
        return await this.waitForPatient(req.response.id, 10);
    }
    async updatePatient(patient: Patient): Promise<void> {
        const accessToken = await Auth0Service.getAccessToken();
        const correctionRequest: PatientCorrectionRequest = patient;
        await grpcRequest(
            accessToken ?? '',
            PatientCommandServiceClient,
            PatientCommandServiceClient.prototype.correctPatientData,
            correctionRequest,
        );
    }

    async waitForPatient(patientId: string, retries: number): Promise<PatientQ> {
        const accessToken = await Auth0Service.getAccessToken();
        try {
            const req  = await grpcRequest(
                accessToken ?? '',
                PatientQueryServiceClient,
                PatientQueryServiceClient.prototype.get,
                {id: patientId},
                {muteErrors: true},
            );
            return req.response;
        }
        catch (e) {
            if (retries >= 0) {
                await new Promise((r) => setTimeout(r, 750));
                return this.waitForPatient(patientId, retries - 1);
            }
            else {
                throw e;
            }
        }
    }
}

export const PatientRequestService = new PatientRequestService_();
